import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_CALIBRATION](state, data) {
    try {
      state.stepStatus = state.cleanStatus
      state.calibration = data
      storage.local.setItem(types.SESSION_STEPSTATUS, null)
      if (state.calibration !== undefined && state.calibration !== null) {
        if (state.calibration !== '') {
          var calibrationState = state.calibration.filter(function (item) {
            return (item.Key === 'state')
          })
          if (calibrationState.length > 0) {
            storage.local.setItem(types.SESSION_STEPSTATUS, calibrationState[0].Calibration)
            state.stepStatus = JSON.parse(calibrationState[0].Calibration)
          }
        }
      }
    } catch (e) {
      console.log('Calibration Retrieval Error', e)
    }
  },
  [types.RESET_STATUS](state) {
    storage.local.setItem(types.SESSION_STEPSTATUS, JSON.stringify({
      techArrived: false, // whenever the tech navigates to the Scan page (first time)
      techReviewedConfig: false, // when the tech clicks on the Configuration tab within Calibration accordion.
      techWorkingReport: false, // whenever the tech is in the Scan Report
      quickscanFirstPair: false, // quick scan device pairing
      quickscanComplete: false, // quick scan complete (set in calibration panel)
      quickscanResult: 0, // pass/fail (set by the master tech in calibration panel)
      quickscanNotes: '', // quick scan notes (set by the master tech in calibration panel)
      preppedCalibration: false, // shop tech sets this (after setting up fixtures)
      scanFirstPair: false, // calibration device pairing
      scanProgress: 0, // set a progress bar
      scanComplete: false, // master tech sets the Complete status in drop down in scan page
      reportSent: false, // show download report button (after master tech hits the Send Final Report)
      prepInstructions: '',
      aimingSnap: ''
    }))
  },
  [types.SET_STATUS](state, data) {
    switch (data.item) {
      case 'devicesPaired':
        state.stepStatus.quickscanFirstPair = true
        state.stepStatus.scanFirstPair = false
        if (state.stepStatus.quickscanComplete) {
          state.stepStatus.scanFirstPair = true
        }
        break
      case 'techArrived':
        state.stepStatus.techArrived = true
        break
      case 'reviewedConfiguration':
        state.stepStatus.techReviewedConfig = true
        break
      case 'quickScanNotes':
        if (data.notes !== undefined) {
          state.stepStatus.quickscanNotes = data.notes
        }
        break
      case 'quickScanResult':
        state.stepStatus.techArrived = true
        state.stepStatus.techReviewedConfig = true
        state.stepStatus.quickscanFirstPair = true
        state.stepStatus.quickscanResult = parseInt(data.value)
        if (
          parseInt(data.value) === 1 ||
          parseInt(data.value) === 2
        ) {
          state.stepStatus.scanProgress = 100
          state.stepStatus.quickscanComplete = true
        } else {
          state.stepStatus.quickscanComplete = false
        }
        if (data.notes !== undefined) {
          state.stepStatus.quickscanNotes = data.notes
        }
        state.stepStatus.scanFirstPair = false
        state.stepStatus.scanComplete = false
        break
      case 'prepComplete':
        state.stepStatus.preppedCalibration = true
        state.stepStatus.scanProgress = 0
        break
      case 'changeProgressScan':
        state.stepStatus.techArrived = true
        state.stepStatus.techReviewedConfig = true
        state.stepStatus.quickscanFirstPair = true
        if (state.stepStatus.quickscanComplete) {
          state.stepStatus.scanFirstPair = true
        }
        state.stepStatus.scanProgress = parseInt(data.value)
        break
      case 'techWorkingReport':
        state.stepStatus.techArrived = true
        state.stepStatus.techReviewedConfig = true
        state.stepStatus.techWorkingReport = true
        break
      case 'completed':
        state.stepStatus.techArrived = true
        state.stepStatus.techReviewedConfig = true
        state.stepStatus.quickscanFirstPair = true
        state.stepStatus.quickscanComplete = true
        state.stepStatus.scanComplete = data.value
        state.stepStatus.scanProgress = 0
        break
      case 'finalReportSent':
        state.stepStatus.techArrived = true
        state.stepStatus.techReviewedConfig = true
        state.stepStatus.quickscanFirstPair = true
        state.stepStatus.quickscanComplete = true
        state.stepStatus.scanComplete = true
        state.stepStatus.techWorkingReport = true
        state.stepStatus.reportSent = data.value
        state.stepStatus.scanProgress = 0
        break
      case 'prepInstructions':
        state.stepStatus.prepInstructions = data.value
        break
      case 'aimingsnap':
        state.stepStatus.aimingSnap = data.value
        break
    }
    storage.local.setItem(types.SESSION_STEPSTATUS, JSON.stringify(state.stepStatus))
  },
  [types.SET_AIMING_URLS](state, data) {
    state.aimingUrls = data
  },
  [types.SET_ALIGNMENTSPECS](state, data) {
    state.alignmentSpecs = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/calibration/mutations.js